import React from 'react'

import type { AnalyticsTableCellType } from '../../../AnalyticsTable.types'
import { AnalyticsTableCellValueFormat } from '../../AnalyticsTableCellValueFormat/AnalyticsTableCellValueFormat'
import type { BreakdownValue } from '../AnalyticsTableCell.types'
import * as S from './TableCellBreakdown.styled'

type TableCellBreakdownProps = BreakdownValue['breakdown'] & {
  type: AnalyticsTableCellType
}

export const TableCellBreakdown = ({ title, items, type }: TableCellBreakdownProps) => {
  return (
    <S.Container>
      {title && <S.Title>{title}</S.Title>}
      <S.Content>
        <S.Column>
          {items.map(({ label }) => (
            <S.Item>
              <S.Label>{label}</S.Label>
            </S.Item>
          ))}
        </S.Column>
        <S.Column>
          {items.map(({ value }) => (
            <S.Item>
              <S.Value>
                <AnalyticsTableCellValueFormat type={type} value={value} />
              </S.Value>
            </S.Item>
          ))}
        </S.Column>
      </S.Content>
    </S.Container>
  )
}
